import Sizes from '../utils/responsive/Sizes';
import { useIsSize } from '../utils/responsive/isSize';

const useBannerOverlap = () => {
  const isLarge = useIsSize(Sizes.LG);

  return isLarge ? 64 : 42;
};

export default useBannerOverlap;
